import { pb } from './pocketbase';

export const getProspectCompanyMemos = async (prospectId) => {
    try {
        const records = await pb.collection('prospect_company_memos').getList(1, 50, {
            filter: `prospect_id="${prospectId}"`,
            sort: '-created',
            expand: 'created_by,prospect_id'
        });
        return records.items;
    } catch (error) {
        if (error.status === 404) {
            return [];
        }
        console.error(`Erreur lors de la récupération des mémos du prospect entreprise ${prospectId}:`, error);
        throw error;
    }
};

export const createProspectCompanyMemo = async (memoData) => {
    try {
        if (pb.authStore.isValid && pb.authStore.model) {
            const memoWithPartnerId = {
                ...memoData,
                partner_id: pb.authStore.record.partner_id
            };
            const createdMemo = await pb.collection('prospect_company_memos').create(memoWithPartnerId);
            return createdMemo;
        } else {
            console.error('Aucun utilisateur authentifié. Impossible de créer le mémo entreprise sans partner_id.');
            return null;
        }
    } catch (error) {
        console.error('Erreur lors de la création du mémo entreprise:', error);
        throw error;
    }
};

export const deleteProspectCompanyMemo = async (memoId) => {
    try {
        await pb.collection('prospect_company_memos').delete(memoId);
        return true;
    } catch (error) {
        console.error(`Erreur lors de la suppression du mémo entreprise ${memoId}:`, error);
        throw error;
    }
};